import { render, staticRenderFns } from "./LiveListN.vue?vue&type=template&id=98de38c0&scoped=true"
import script from "./LiveListN.vue?vue&type=script&lang=js"
export * from "./LiveListN.vue?vue&type=script&lang=js"
import style0 from "./LiveListN.vue?vue&type=style&index=0&id=98de38c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98de38c0",
  null
  
)

export default component.exports